export default __webpack_public_path__ + "static/media/cross-circle.36e4ffbf.svg";